import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

const monthStart = () => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10); };
const todayIso = () => new Date().toISOString().slice(0, 10);
const lastMonthRange = () => {
  const d = new Date();
  const iso = (x) => x.toISOString().slice(0, 10);
  return { from: iso(new Date(d.getFullYear(), d.getMonth() - 1, 1)), to: iso(new Date(d.getFullYear(), d.getMonth(), 0)) };
};

export default function MyWorkActivity() {
  const { user } = useAuth();
  const eligible = !!user?.is_field_user && !user?.is_admin;
  const [from, setFrom] = useState(monthStart());
  const [to, setTo] = useState(todayIso());
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    if (!eligible || !from || !to) return;
    api.get("/dashboard/my-work-activity", { params: { date_from: from, date_to: to } })
      .then((r) => setData(r.data)).catch(() => setData(null));
  }, [eligible, from, to]);
  useEffect(() => { load(); }, [load]);

  if (!eligible) return null;

  return (
    <div className="mt-4" data-testid="my-work-activity">
      <div className="mb-3 flex flex-wrap items-end justify-between gap-2">
        <h2 className="font-display text-lg font-semibold text-slate-900">My Work Activity{data?.member_name ? ` — ${data.member_name}` : ""}</h2>
        <div className="flex flex-wrap items-end gap-2">
          <div className="flex items-center gap-1 pb-0.5">
            <Button data-testid="mwa-this-month" size="sm" variant="outline" className="h-8" onClick={() => { setFrom(monthStart()); setTo(todayIso()); }}>This Month</Button>
            <Button data-testid="mwa-last-month" size="sm" variant="outline" className="h-8" onClick={() => { const r = lastMonthRange(); setFrom(r.from); setTo(r.to); }}>Last Month</Button>
          </div>
          <div><Label className="text-xs text-slate-500">From</Label><Input data-testid="mwa-from" type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} className="mt-1 h-8 w-40" /></div>
          <div><Label className="text-xs text-slate-500">To</Label><Input data-testid="mwa-to" type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} className="mt-1 h-8 w-40" /></div>
          <Button data-testid="mwa-clear" size="sm" variant="ghost" className="h-8 text-slate-500 hover:text-slate-800" title="Reset to this month" onClick={() => { setFrom(monthStart()); setTo(todayIso()); }}>Clear</Button>
        </div>
      </div>
      {!data?.linked ? (
        <p className="rounded-xl border bg-white px-4 py-6 text-sm text-slate-400" data-testid="mwa-unlinked">Your account is not linked to a member code — contact an administrator.</p>
      ) : (
        <div className="grid max-w-2xl grid-cols-3 gap-3">
          <div className="rounded-lg border border-amber-200 bg-amber-50 p-3"><div className="text-[11px] font-medium uppercase text-amber-600">Draft</div><div className="mt-1 text-xl font-bold text-amber-700" data-testid="mwa-draft">{data?.draft ?? 0}</div></div>
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3"><div className="text-[11px] font-medium uppercase text-emerald-600">Completed</div><div className="mt-1 text-xl font-bold text-emerald-700" data-testid="mwa-completed">{data?.completed ?? 0}</div></div>
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3"><div className="text-[11px] font-medium uppercase text-slate-500">Total Entries</div><div className="mt-1 text-xl font-bold text-slate-700" data-testid="mwa-total">{data?.total ?? 0}</div></div>
        </div>
      )}
    </div>
  );
}
